import React from 'react'
import _ from 'underscore'
import LeadSubjectsPartial from './partial'
import CreateLeadSubject from './create'

class LeadSubjects extends React.Component {

  render() {
    return (
      <div className="grid gap-3">
        {this.props.subjects.length > 0 ?
          <div className="divide-y rounded-[10px] border border-border bg-card">
            {_.map(this.props.subjects, (subject) => {
              return (
                <LeadSubjectsPartial
                  key={subject.name}
                  subject={subject}
                  lead={this.props.lead}
                  store={this.props.store}
                />
              )
            })}
          </div>
          : null
        }
        <CreateLeadSubject
          lead={this.props.lead}
          store={this.props.store}
        />
      </div>
    )
  }
}

export default LeadSubjects
